import React from 'react';

import BaseIcon from './base';
import path from '../../../assets/Dashboard/bike.svg';

export default function BikeSvgIcon({ classes }) {
  return (
    <BaseIcon classes={classes} altText="scooter" path={path} />
  );
}
